import React from 'react'
import { useNavigate } from 'react-router-dom';
import TopNavigation from '../Components/navigation/TopNavigation';
import MainFooter from '../Components/footer/MainFooter';
import { useDispatch } from 'react-redux';
import { logout } from '../reduxAuth/authSlice';

function AccessDenied() {

    const dispatch                                                      = useDispatch();
    const navigate                                                      = useNavigate();

  const handleLogout = () => {
     dispatch(logout());
      navigate("/");
  }
  return (
    <div className="main-layer">
        <TopNavigation title={"Access Denied"} classBack="full-white"/>
        <div className="content-layer">
          <div className="section-item">
            <div className="container min-sect text-center">
                <h1>Access Denied</h1>
                <h2>Sorry but you have not access to view this page</h2>

                <button className="mt-4" onClick={handleLogout}>
                  Logout 
                </button>
            </div>
          </div>
            
        </div>
        <MainFooter />
    </div>
  )
}

export default AccessDenied